module.exports = {
  purge: [
    './src/**/*.vue',
    './src/**/*.js',
  ],
  theme: {
    extend: {
      colors: {
        primary: '#0881b8',
        secondary: '#4c5f72',
        accent: '#2c3741',
        action: {
          default: '#dd6a20',
          dark: '#d26b33',
        }
        
      },
      fontSize: {
        '2r': '2rem',
        }
    },
  },
  variants: {},
  plugins: [],
}
